import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import WmTextarea from "../ui-components/wm-form-components/textarea/Wm.Textarea";
import "./posts.css";
import Categories from "../ui-components/categories/Categories";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import FileUploader from "../ui-components/fileUploader/FileUploader";
import InputTags from "../ui-components/tags/InputTags";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Editor from "../Components/Editor/Editor";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import { decode } from "base-64";
import Cookies from "universal-cookie";
// ACTIONS
import { setSinglePostData, editTitleBlogs, editDescriptionBlogs, editContentBlogs, removeEditHeadImageBlogs, editCommentBlogs, editTagsBlogs, editHeadImageBlogs, fetchCategoryFromApiEdit, editCategoryCheck, cleanUpBlogState, isFetchedBlog } from "../services/actions/actions";
import WmModals from "../modals/Wm.Modals";
import { useQuery } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { getSinglePostData } from "../functions/posts";
import ServerError from "../Pages/error/500/ServerError";
import Loading from "../Loading/Loading";
import { CheckCircleIcon, ClipboardCopyIcon, XIcon } from "@heroicons/react/outline";
const Cookie = new Cookies();
function EditBlog({ mapDataToState, blogData, editTitle, editDescription, editContent, removeBlogImage, editTags, handleCoverImage, getCategoryFormApi, handleCategoryCheck}) {
  var tokens = Cookie.get("wmtoken");
  const history = useHistory();
  const lastSegmentOfUrl = window.location.pathname.split("/").pop();
  const blogsPreview = () => {
    history.push(`/editpreview_blogs`);
  };
  const [isPublishing, setIspublishing] = useState(false);
  const [publishLinkModal, setOpenPublishLinkModal] = useState(false)
  const [linkCopied, setLinkCopied] = useState(false)
  const EditBlogData = (e) => {
    setIspublishing(true);
    var fd = new FormData();
    fd.append("token", decode(tokens));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("post_type", "blog");
    fd.append("post_id", blogData.blogPostID);
    fd.append("content", blogData.editContent);
    fd.append("title", blogData.editQuestion);
    fd.append("description", blogData.editDescription);
    fd.append("reply_status", blogData.editIsComment ? "1" : "0");
    blogData.editBlogFile && fd.append("post_media", blogData.editBlogFile)
    fd.append("category", JSON.stringify([...blogData.editCategory]));
    fd.append("tags", JSON.stringify([...blogData.editTags]));
    axios({ method: "post", url: `${API_ENDPOINT.apiURL}Profile/updatePost`, data: fd })
      .then(function () {
        setIspublishing(false);
        setOpenPublishLinkModal(true)
      })
      .catch(function (error) {
        setIspublishing(false);
        alert(error.response.data.validation_error);
      });
  };
  const copyLink = (text) => {
    navigator.clipboard.writeText(text).then(function () {
      setLinkCopied(true)
      history.push(`/posts`);
    }, function (err) {
      alert(err)
    });
  }
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteAnswer = () => {
    setIsDeleting(true);
    var fd = new FormData();
    if (tokens) {
      fd.append("token", decode(tokens));
      fd.append("identity", "wmhandler");
      fd.append("field_id", blogData.blogPostID);
      fd.append("field_name", "POST");
      axios({
        method: "post",
        url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
        data: fd,
      })
        .then(function () {
          setIsDeleting(false);
          history.push(`/posts`);
        })
        .catch(function () {
          setIsDeleting(false);
        });
    }
  };
  const [deleteModal, setIsDeleteModalOpen] = useState(false);
  const backToLoginPage = () => {
    history.push("/login");
  };

  const { isError, isLoading, isSuccess, error } = useQuery(['singleBlogData', lastSegmentOfUrl], getSinglePostData, { refetchOnWindowFocus: false, onSuccess: data => { mapDataToState(data) } })

  if (isLoading) return <><div className="flex items-center justify-center"><Loading className={'w-48'} /></div></>;

  if (isError) return <><div><ServerError message={error.response.status} /></div></>

  if (isSuccess) return (
    <React.Fragment>
      {tokens ? <div className="createBlog -mt-8 container-fluid">
        <h3 className=" mb-4">Edit Posts</h3>
        <div className="wm-form-group flex flex-col mb-4">
          <label htmlFor="First name" className="text-sm">Enter Title Here</label>
          <Wminput type="text" name="blogTitle" value={blogData.editQuestion} onChange={(e) => editTitle(e.target.value.replace(/[^\w\s "':-]/gi, ""))} />
        </div>
        <div className="row createFormLayoutDivision flex">
          <div className="col-xl-9 col-lg-9 col-md-9">
            <div className="leftCreateSection">
              <div className="wm-form-group flex flex-col mb-4">
                <label htmlFor="First name" className="text-sm">Description</label>
                <WmTextarea value={blogData.editDescription} onChange={(e) => editDescription(e.target.value)} />
              </div>
              <div className="uploadArea h-40 w-full">
                <FileUploader handleCoverImageUpload={(e) => handleCoverImage(e)} image={blogData.editHeadImage} removeHeadImage={removeBlogImage} allowTypes={"image/png, image/jpeg, image/jpg"} />
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-3 mt-4 lg:mt-0">
            <div className="rightCreateSection">
              <div className="wm-form-group mb-4">
                <div className="catogryWrapper border rounded-md p-3">
                  <Categories mainCategoriesClass="categoryContainer" list={blogData.editCategoryStore} getCategory={getCategoryFormApi} checkBoxHandler={handleCategoryCheck} listFromRedux={blogData.editCategory} />
                </div>
              </div>
              <div className="wm-form-group mb-4">
                <h5 className="mb-2 font-medium text-sm">Tags</h5>
                <div className="tagsWrapper">
                  {blogData.editTags && <InputTags selected={blogData?.editTags} getTags={editTags} />}
                </div>
                <p className="text-gray-600 text-xs manpro mt-3">Please hit <span className="px-2 py-1 bg-gray-300 rounded inline-block">Enter</span> after every tag.</p>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="textEditor mt-4">
              <Editor value={blogData.editContent} onEditorStateChange={(e, value) => editContent(value)} />
            </div>
            <div className="wm-form-group mb-4 flex space-x-4 mt-4">
              <div className="">
                <Wmbutton label="Preview" className="rounded mb-3 mr-0 w-full px-4" type="button" color="primary" onClick={(e) => blogsPreview(e)} />
              </div>
              <div className="">
                <Wmbutton label={isPublishing ? (<CircularProgress className="loader_size_xsm" style={{ color: "white" }} />) : ("Publish")} className="rounded mb-3 mr-0 w-full px-4" type="button" color="primary" onClick={() => EditBlogData(blogData)} disable={isPublishing} />
              </div>
              <div className="">
                <Wmbutton label={isDeleting ? (<CircularProgress className="loader_size_xsm" style={{ color: "white" }} />) : ("Delete")} className="rounded mb-3 w-full px-4" type="button" color="danger" disable={isDeleting} onClick={() => { setIsDeleteModalOpen(true); }} />
              </div>
              <div className="">
                <Wmbutton label="Back" className="rounded mb-3 w-full px-4" type="button" color="primary" onClick={() => history.push(`/posts`)} />
              </div>
            </div>
          </div>
        </div>
      </div> : backToLoginPage()}
      <WmModals show={deleteModal} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
        <Container fluid className="py-4">
          <Row>
            <Col md={12}>
              <div className="text-center mb-4">
                <span className="block">Are you sure you want to Delete the content</span>
                <span className="block">This will erase all above content permenantly!!!!</span>
              </div>
            </Col>
            <Col md={12}>
              <div className="text-right">
                <Wmbutton label="Delete" className="rounded w-20 mr-3" type="button" size="sm" color="danger" onClick={(e) => { deleteAnswer(); setIsDeleteModalOpen(false); }} />
                <Wmbutton label="Cancel" className="rounded w-20" type="button" color="primary" onClick={() => { setIsDeleteModalOpen(false); }} />
              </div>
            </Col>
          </Row>
        </Container>
      </WmModals>

      <WmModals show={publishLinkModal} onHide={() => { setOpenPublishLinkModal(false); setLinkCopied(false) }} size="md" className="overflow-hidden">
        <div className="relative">
          <XIcon className=" absolute w-5 text-black right-4 top-4 cursor-pointer" onClick={() => { setOpenPublishLinkModal(false); setLinkCopied(false); window.location.reload(false); }} />
          <div className="w-full h-48 flex items-center justify-center bg-green-200">
            <CheckCircleIcon className="w-20 h-20 text-green-700" />
          </div>
          <div className="text-center p-4">
            <span className="block manpro text-4xl text-gray-700">Great!</span>
            <span className="block manpro text-lg text-gray-700 font-semibold my-3">Your blog is published successfully.</span>
            {linkCopied && <span className="bg-green-200 text-green-700 px-3 py-1 rounded inline-block mb-2">Copied to clipboard</span>}
            <div>
              <div onClick={() => copyLink(`${API_ENDPOINT.redirectURL}/blogs/${lastSegmentOfUrl}`)} className="flex items-center justify-between cursor-pointer border rounded-md py-2  px-3 divide-x hover:shadow">
                <span className="block wordClamp-1">{`${API_ENDPOINT.redirectURL}/blogs/${lastSegmentOfUrl}`}</span>
                <ClipboardCopyIcon className="w-10 pl-3" />
              </div>
            </div>
          </div>
        </div>
      </WmModals>
      <ReactQueryDevtools initialIsOpen={false} />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    mapDataToState: (value) => {
      dispatch(setSinglePostData(value));
    },
    editTitle: (value) => {
      dispatch(editTitleBlogs(value));
    },
    editDescription: (value) => {
      dispatch(editDescriptionBlogs(value));
    },
    editContent: (value) => {
      dispatch(editContentBlogs(value));
    },
    editComment: (value) => {
      dispatch(editCommentBlogs(value));
    },
    editTags: (value) => {
      dispatch(editTagsBlogs(value));
    },
    removeBlogImage: (value) => {
      dispatch(removeEditHeadImageBlogs(value));
    },
    handleCoverImage: (value) => {
      dispatch(editHeadImageBlogs(value));
    },
    getCategoryFormApi: (value) => {
      dispatch(fetchCategoryFromApiEdit(value));
    },
    handleCategoryCheck: (idx, value, bool) => {
      dispatch(editCategoryCheck(idx, value, bool));
    },
    runCleanUp: () => {
      dispatch(cleanUpBlogState());
    },
    isFetchedBlogs: (value) => {
      dispatch(isFetchedBlog(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToState)(EditBlog);
